import React from "react";
import { Modal, Button, Typography, Result } from "antd";
import { useTourStore } from "../../store/tourStore";

const { Text } = Typography;

export const TourSuccessModal = () => {
    const {
        isFinished,
        isCompletedSuccessfully,
        successModalSeen,
        tourMode,
        closeSuccessModal
    } = useTourStore();

    const isVisible = isFinished && isCompletedSuccessfully && !successModalSeen;

    if (!isVisible) return null;

    const successMessage = tourMode === 'marketplace'
        ? "Готово, ваши товары опубликованы на маркетплейсе быстро и точка."
        : "Готово, вы можете использовать tableCRM для увеличения продаж и учета.";

    return (
        <Modal
            open={isVisible}
            closable={false}
            footer={null}
            centered
            maskClosable={false}
        >
            <Result
                status="success"
                title="Обучение успешно завершено!"
                subTitle={<Text style={{ fontSize: '16px' }}>{successMessage}</Text>}
                extra={[
                    <Button type="primary" key="console" onClick={closeSuccessModal} size="large">
                        Приступить к работе
                    </Button>,
                ]}
            />
        </Modal>
    );
};
